import Rest from '@/services/Rest';

export default class DocumentationStatusService extends Rest {
  static resource = '/documentation-status';
  
  static build() {
    return super.build(this.resource);
  }
} 